export const ActionTypes = 
{
    LOGIN : "LOGIN",
    LOGOUT : "LOGOUT",
    SHOW_NOTE: "SHOW_NOTE",
    SET_SESSION_TIMEOUT: "SET_SESSION_TIMEOUT",
}